import React from 'react';

/**
 * G5E — chips de papéis (roles) de um vínculo contato↔entidade.
 * `roleLabel` mapeia o value para o label_pt (via useRoleLabels); fallback = value cru.
 */
export default function RoleChips({ roles, roleLabel, className = '' }) {
  const list = Array.isArray(roles) ? roles : [];
  if (list.length === 0) return null;
  return (
    <span className={`inline-flex flex-wrap gap-1 ${className}`}>
      {list.map((r, i) => (
        <span
          key={`${r}:${i}`}
          className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-indigo-100 text-indigo-700"
        >
          {roleLabel ? roleLabel(r) : r}
        </span>
      ))}
    </span>
  );
}
